<template>
    <div class="ion-page">
      <ion-content class="ion-padding">
        <Login />
      </ion-content>
    </div>
  </template>
  
  <script>
  import { IonContent } from "@ionic/vue";
  // @ is an alias to /src
  import Login from "@/components/account/Login.vue";
  
  export default {
    name: "login",
    components: {
      IonContent,
      Login
    }
  };
  </script>